<i18n
  src="@/locales/views/agro_exporter/finances/container_incomes/show_container.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/export_invoice.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('show_process_containers')"
    :params="{
      agro_exporter_id: agro_exporter_id,
      agro_exporter_process_id: agro_exporter_process_id
    }"
  >
  </go-back-link>

  <bread-crumbs :labels="[module_name, agro_exporter_process.name]" />

  <template v-if="load_data_general">
    <div class="mt-8">
      <container-info :agro_exporter_id="agro_exporter_id" :container="container" />
    </div>

    <div class="mt-8 flex flex-row">
      <h1 class="page-title">
        <i class="fa-solid fa-file-invoice-dollar"></i>
        <span class="space-icon"></span>
        {{ $t("labels.title_export_invoices") }}
      </h1>
    </div>
    <div class="mt-8 flex flex-row justify-between">
      <div class="panel-plain-label space-x-4">
        <badge-default
          :label="
            export_invoices.length +
            ' ' +
            $t('labels.total_number_export_invoices')
          "
        />
        <badge-default
          :label="
            export_invoices_paid +
            ' ' +
            $t('labels.total_number_export_invoices_paid')
          "
        />
      </div>
      <new-button
        @click.prevent="goToNewExportInvoice()"
        :label="$t('labels.new_button')"
      />
    </div>

    <div class="mt-8 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.export_invoice.invoice_date") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.export_invoice.invoice_code") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.export_invoice.amount") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.export_invoice.amount_paid") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.export_invoice.paid") }}
                  </th>
                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="export_invoice in export_invoices"
                  :key="export_invoice.id"
                >
                  <td class="table-cell">
                    {{ dateFormatter(export_invoice.invoice_date) }}
                  </td>
                  <td
                    class="table-cell-main link"
                    @click="goToShowExportInvoice(export_invoice)"
                  >
                    {{ export_invoice.invoice_code }}
                  </td>
                  <td class="table-cell">
                    {{
                      currencyMoney(
                        export_invoice.amount,
                        export_invoice.currency.symbol
                      )
                    }}
                  </td>
                  <td class="table-cell">
                    {{
                      currencyMoney(
                        export_invoice.amount_paid,
                        export_invoice.currency.symbol
                      )
                    }}
                  </td>
                  <td class="table-cell">
                    <yes-no-label :value="export_invoice.paid" />
                  </td>
                  <td class="table-cell-action">
                    <pay-export-invoice-button
                      :paid="export_invoice.paid"
                      @payExportInvoice="updateExportInvoice(export_invoice)"
                    ></pay-export-invoice-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/finances/container_incomes/show_container.js";
import ManageExportInvoiceRequester from "@/views/agro_exporter/requesters/finances/container_incomes/manage_export_invoice.js";
import ContainerInfo from "@/components/views/agro_exporter/finances/container_incomes/ContainerInfo.vue";
import PayExportInvoiceButton from "@/components/views/agro_exporter/finances/container_incomes/PayExportInvoiceButton.vue";

export default {
  name: "AEFinancesContainerIncomesShowExportInvoice",
  components: { ContainerInfo, PayExportInvoiceButton },
  props: {
    agro_exporter_process_id: { required: true },
    agro_exporter_id: { required: true },
    container_id: { required: true }
  },
  data() {
    return {
      load_data_general: false,
      proc_save_button: false,
      proc_button_destroy: false,
      agro_exporter_process: {},
      container: {},
      export_invoices: []
    };
  },
  computed: {
    export_invoices_paid: function () {
      return this.export_invoices.filter(export_invoice => export_invoice.paid)
        .length;
    }
  },
  methods: {
    loadData: async function () {
      await this.fetchAgroExporterProcess();
      await this.fetchContainer();
      await this.fetchExportInvoices();
      this.load_data_general = true;
    },
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchContainer: async function () {
      let response = await Requester.fetchContainer(
        this.agro_exporter_id,
        this.container_id
      );
      this.container = response.data;
    },
    fetchExportInvoices: async function () {
      let response = await Requester.fetchExportInvoices(
        this.agro_exporter_id,
        this.container_id
      );
      this.export_invoices = response.data;
    },
    updateExportInvoice: async function (export_invoice) {
      this.proc_save_button = true;
      try {
        let response = await ManageExportInvoiceRequester.update(
          this.agro_exporter_id,
          export_invoice.id,
          {
            paid: !export_invoice.paid
          }
        );
        let export_invoice_update = response.data.export_invoice;
        export_invoice.paid = export_invoice_update.paid;
        export_invoice.amount_paid = export_invoice_update.amount_paid;
        this.container.export_invoices_paid =
          this.export_invoices.filter(invoice => invoice.paid).length ==
          this.export_invoices.length;
        this.registerSuccessNotification({
          title: response.data.success_message
        });
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
      }
      this.proc_save_button = false;
    },
    goToNewExportInvoice: function () {
      this.$router.push({
        name: this.routeName("new_export_invoice"),
        params: {
          agro_exporter_id: this.agro_exporter_id,
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id
        }
      });
    },
    goToShowExportInvoice: function (export_invoice) {
      this.$router.push({
        name: this.routeName("show_export_invoice"),
        params: {
          agro_exporter_id: this.agro_exporter_id,
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id,
          export_invoice_id: export_invoice.id
        }
      });
    },
    goToShowProcess: function () {
      this.$router.push({
        name: this.routeName("show_process_export_invoices"),
        params: {
          agro_exporter_id: this.agro_exporter_id,
          agro_exporter_process_id: this.agro_exporter_process_id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => this.loadData())
    );
  }
};
</script>
